import * as Sentry from '@sentry/browser';

const prepareSentry: () => void = () => {
  if (process.env.REACT_APP_ENV !== 'development' && process.env.REACT_APP_ENV !== 'mirage') {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DNS,
      environment: process.env.REACT_APP_ENV,
      release: process.env.REACT_APP_VERSION,
      ignoreErrors: ['ChunkLoadError', /Loading chunk \d failed/i],
    });
  }
};

export default prepareSentry;
